import React, {ReactNode} from 'react';
import I18n from 'app/i18n';
import x2BonusBet from 'images/user-promotions-promo/x2-bets.png';
import x2BonusCasino from 'images/user-promotions-promo/x2-casino.png';

interface PropsInterface {
    bonusType: string
    localePromotionTitle: string
    svgIconName: string
    localePromotionText: string
    bannerType: string
    svgIconGameType?: string
    active: boolean
    onClick: () => void
}

export default class DepositBonusTypeButton extends React.Component<PropsInterface> {
    onClick = (): void => {
        this.props.onClick();
    };

    render(): ReactNode {
        const {active, bonusType} = this.props;

        return <button
            className={`deposit-bonus-button ${active ? 'active' : ''}`}
            onClick={this.onClick}
        >
            <div className="deposit-bonus-button__image">
                <img src={bonusType === 'casino' ? x2BonusCasino : x2BonusBet} alt={`x2 bonus ${bonusType}`} />
            </div>
            <div className="deposit-bonus-button__title">
                <div className="deposit-bonus-button__circle"/>
                <span>{I18n.t(`promo_bonus_${bonusType}_title`)}</span>
            </div>
        </button>;
    }
}
